// document.addEventListener('DOMContentLoaded', function () {
 
//   var animatedSelectors = [
//     '.section_slideUp',
//     '.title_slideUp',
//     '.text_slideUp',
//     '.image_slideUp',
//     '.image_slideLeft',
//     '.image_slideRight'
//   ];
 
//   // Aa selectors ni andar je pan elements hoy, temne animation NA aapvi
//   var excludeParentSelector =
//     '.swiper, .swiper-container, .swiper-wrapper, .swiper-slide, ' +
//     '.slick-slider, .slick-slide, .slick-track, ' +
//     '[class*="slider"], [class*="Slider"], [class*="carousel"], [class*="Carousel"]';
 
//   var elements = document.querySelectorAll(animatedSelectors.join(','));
 
//   // Element abhi viewport ma dekhay che ke nahi e check karva mate
//   function isInViewport(el) {
//     var rect = el.getBoundingClientRect();
//     var winHeight = window.innerHeight || document.documentElement.clientHeight;
//     // thodu margin rakhyu che jethi edge par hoy to pan count thay
//     return rect.top < winHeight - 50 && rect.bottom > 0;
//   }
 
//   function revealNow(el) {
//     // double rAF -> browser ne hidden state pehla paint karva nu time male,
//     // pachi class add thay etle transition smooth chale (jump nai thay)
//     requestAnimationFrame(function () {
//       requestAnimationFrame(function () {
//         el.classList.add('is-inview');
//       });
//     });
//   }
 
//   if (!('IntersectionObserver' in window)) {
//     // Old browser fallback - badhu j direct visible
//     elements.forEach(function (el) { el.classList.add('is-inview'); });
//     return;
//   }
 
//   var observer = new IntersectionObserver(function (entries, obs) {
//     entries.forEach(function (entry) {
//       if (entry.isIntersecting) {
//         entry.target.classList.add('is-inview');
//         obs.unobserve(entry.target); // ek j vaar animate, re-trigger nai thay
//       }
//     });
//   }, {
//     root: null,
//     threshold: 0.15,
//     rootMargin: '0px 0px -80px 0px'
//   });
 
//   elements.forEach(function (el) {
 
//     // Slider/Swiper andar hoy to skip + force visible (no animation)
//     if (el.closest(excludeParentSelector)) {
//       el.classList.add('is-inview');
//       el.classList.add('no-animate');
//       return;
//     }
 
//     // Stagger delay support: <div class="text_slideUp" data-delay="200">
//     var delay = el.getAttribute('data-delay');
//     if (delay) {
//       el.style.transitionDelay = delay + 'ms';
//     }
 
//     if (isInViewport(el)) {
//       // Page load thay tyare j screen ma dekhatu content -> immediately animate
//       revealNow(el);
//     } else {
//       // Baki nu content -> scroll kari ne aave tyare animate
//       observer.observe(el);
//     }
//   });
 
//   // Images/fonts load thaya pachi layout shift thay (hero banners etc.)
//   // -> ek vaar recheck kari le je elements have viewport ma aavi gaya hoy
//   document.addEventListener('DOMContentLoaded', () => {
//     elements.forEach(function (el) {
//       if (!el.classList.contains('is-inview') && !el.classList.contains('no-animate')) {
//         if (isInViewport(el)) {
//           observer.unobserve(el);
//           revealNow(el);
//         }
//       }
//     });
//   });
 
// });


document.addEventListener('DOMContentLoaded', function () {
 
  var animatedSelectors = [
    '.section_slideUp',
    '.title_slideUp',
    '.text_slideUp',
    '.image_slideUp',
    '.image_slideLeft',
    '.image_slideRight'
  ];
 
  // Aa selectors ni andar je pan elements hoy, temne animation NA aapvi
  var excludeParentSelector =
    '.swiper, .swiper-container, .swiper-wrapper, .swiper-slide, ' +
    '.slick-slider, .slick-slide, .slick-track, ' +
    '[class*="slider"], [class*="Slider"], [class*="carousel"], [class*="Carousel"]';
 
  var elements = document.querySelectorAll(animatedSelectors.join(','));
 
  // Element abhi viewport ma dekhay che ke nahi e check karva mate
  function isInViewport(el) {
    var rect = el.getBoundingClientRect();
    var winHeight = window.innerHeight || document.documentElement.clientHeight;
    return rect.top < winHeight - 50 && rect.bottom > 0;
  }
 
  function revealNow(el) {
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        el.classList.add('is-inview');
      });
    });
  }
 
  if (!('IntersectionObserver' in window)) {
    elements.forEach(function (el) { el.classList.add('is-inview'); });
    return;
  }
 
  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        // Viewport ma aavyu -> animate in
        entry.target.classList.add('is-inview');
      } else {
        // Viewport ni bahar gayu (scroll up ke down banne) -> hidden state ma reset
        entry.target.classList.remove('is-inview');
      }
    });
  }, {
    root: null,
    threshold: 0.15,
    rootMargin: '0px 0px -80px 0px'
  });
 
  elements.forEach(function (el) {
 
    // Slider/Swiper andar hoy to skip + force visible (no animation, never reset)
    if (el.closest(excludeParentSelector)) {
      el.classList.add('is-inview');
      el.classList.add('no-animate');
      return;
    }
 
    // Stagger delay support: <div class="text_slideUp" data-delay="200">
    var delay = el.getAttribute('data-delay');
    if (delay) {
      el.style.transitionDelay = delay + 'ms';
    }
 
    // Hamesha observe karo -> scroll up/down banne vakhate toggle thase
    observer.observe(el);
 
    // Page load thay tyare j screen ma dekhatu hoy to immediately reveal
    if (isInViewport(el)) {
      revealNow(el);
    }
  });
 
});